module.exports = __webpack_public_path__ + "static/media/auth_top.576680ab.svg";